import * as Sentry from '@sentry/react';

export const initSentry = () => {
	Sentry.init({
		dsn: process.env.REACT_APP_SENTRY_DSN,
		environment: process.env.REACT_APP_ENVIRONMENT || 'development',
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
			}),
		],
		tracesSampleRate: process.env.REACT_APP_ENVIRONMENT === 'production' ? 0.1 : 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		beforeSend(event, hint) {
			if (event.exception && process.env.REACT_APP_ENVIRONMENT === 'development') {
				console.error('Sentry error:', hint.originalException);
			}
			return event;
		},
	});
};
